import React from 'react';
import cn from '@/utils/cn';
import { iconVariant, TIconColor } from './iconVariant';
import { IconProps } from './types/IconInterface';

interface MagnifyingGlassProps extends IconProps {
  color?: TIconColor;
}

const MagnifyingGlass = ({ size, variant, className, color = 'white' }: MagnifyingGlassProps) => (
  <svg
    className={cn(iconVariant({ size, variant, iconColor: color, className }))}
    aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 16 16">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.2001 2.8001C4.77005 2.8001 2.8001 4.77005 2.8001 7.2001C2.8001 9.63015 4.77005 11.6001 7.2001 11.6001C8.41529 11.6001 9.51447 11.1083 10.3114 10.3114C11.1083 9.51447 11.6001 8.41529 11.6001 7.2001C11.6001 4.77005 9.63015 2.8001 7.2001 2.8001ZM1.6001 7.2001C1.6001 4.1073 4.1073 1.6001 7.2001 1.6001C10.2929 1.6001 12.8001 4.1073 12.8001 7.2001C12.8001 8.53011 12.3358 9.75255 11.5615 10.7129L14.2244 13.3758C14.4587 13.6101 14.4587 13.99 14.2244 14.2244C13.99 14.4587 13.6101 14.4587 13.3758 14.2244L10.7129 11.5615C9.75255 12.3358 8.53011 12.8001 7.2001 12.8001C4.1073 12.8001 1.6001 10.2929 1.6001 7.2001Z"
      fill="currentColor"
    />
  </svg>
);

export default MagnifyingGlass;
